import React, { useEffect, useState } from 'react'
// import './App.css'

type Dictionary<TKey extends string | number | symbol, TValue> = { [key in TKey]: TValue; };


async function LoadCompatibleInkCartridgeData(jsonUrl: string): Promise<any> {
    try {
        const response = await fetch(jsonUrl)
        const data = response.json()
        return data
    } catch (error) {
        throw error
    }
}
type CompatibleInkCartridgeTableProps = {
    manufacturer: string
    rows: any[]
    spanMap: RowSpanMap[]
    idx: Dictionary<string, number[]>
}
type RowSpanMap = {
    col01: number
    col02: number
    col03: number
    col04: number
    col05: number
    col06: number
    col07: number
}
const CompatibleInkCartridgeTable = (props: CompatibleInkCartridgeTableProps): JSX.Element => {
    return (
        <div className='table-block'>{  /* MOD20240125001: 表ごとに横スクロール */}
            <table className="inkList-table tableB" summary="互換インク商品一覧">
                <thead className="scrollHead">
                    <tr className='head1'>
                        <th className='col01 manufacturer' colSpan={7}>{props.manufacturer}</th>
                    </tr>
                    <tr className='head2'>
                        <th className="col01 lineNo">No</th>
                        {/* <th className="col02 note">状態</th> */}
                        <th className="col03 seriesName">シリーズ名</th>
                        <th className="col04 ggName">G&G商品名</th>
                        <th className="col05 shohinName">純正商品名</th>
                        <th className="col06 injiMaisu">印字枚数</th>
                        <th className="col07 tekiouKiki">代表的な適応機器</th>
                    </tr>
                </thead>
                <tbody className="scrollBody">
                    {
                        props.idx[props.manufacturer].map((value: number, index: number, array: number[]) => {
                            return (
                                <>
                                    <tr className={`${index % 2 === 1 ? 'odd' : 'even'} ${props.spanMap !== undefined &&
                                            props.spanMap[value] !== undefined &&
                                            props.spanMap[value].col07 !== undefined &&
                                            props.spanMap[value].col07 > 0 ? 'break':''}`}>
                                        <td className='col01 lineNo'>{index + 1}</td>
                                        {/* <td className='col02 note'>{props.rows[value].note}</td> */}
                                        <td className='col03 seriesName' title={props.rows[value].seriesName}>{props.rows[value].seriesName}</td>
                                        <td className='col04 ggName' title={props.rows[value].ggName}>{props.rows[value].ggName}</td>
                                        <td className='col05 shohinName' title={props.rows[value].shohinName}>{props.rows[value].shohinName}</td>
                                        <td className='col06 injiMaisu' title={props.rows[value].injiMaisu}>{props.rows[value].injiMaisu}</td>
                                        {
                                            props.spanMap !== undefined &&
                                            props.spanMap[value] !== undefined &&
                                            props.spanMap[value].col07 !== undefined &&
                                            props.spanMap[value].col07 > 0 ? 
                                                <td className='col07 tekiouKiki' title={props.rows[value].tekiouKiki} rowSpan={props.spanMap[value].col07} >{props.rows[value].tekiouKiki}</td>
                                                :
                                                <></>
                                        }
                                    </tr>
                                </>
                            )
                        })
                    }
                </tbody>
            </table>
            <div className="notice">※印字枚数はA4用紙に、ISO/IEC24712に基づき印字した場合の参考値です。</div>
        </div>
    )
}

const App = () => {
    const [data, setData] = useState<any[]>([])
    const [idx, setIdx] = useState<Dictionary<string, number[]>>({})
    const [itemNo, setItemNo] = useState<number>(0)
    const [rowSpanMap, setRowSpanMap] = useState<RowSpanMap[]>([])

    const loadData = () => {
        LoadCompatibleInkCartridgeData('data/ink.json')
            .then((data: any[]) => {
                setData(data)

                const rows: Dictionary<string, number[]> = {}
                data.map<void>((value: any, index: number, array: any[]) => {
                    if (index > 0) {
                        /* if (value.note !== '終売') */ // MOD20240125001: '終売'は表示しないよう指示あり from ishii
                        /* { */
                            if (rows.hasOwnProperty(value.manufacturer)) {
                                rows[value.manufacturer].push(index)

                            } else {
                                rows[value.manufacturer] = [index]
                            }
                        /* } */
                    }
                })
                setIdx(rows)
            })
    }
    const createRowSpanMap = () => {
        let spanMap: RowSpanMap[] = []
        for (let index = 0; index < data.length; index++)
        {
            spanMap.push({col01:0,col02:0,col03:0,col04:0,col05:0,col06:0,col07:0})
        }
        //col07
        let prevColData: string = ''
        let prevRowIndex: number = 0;
        //
        for (let index = 0; index < data.length;index++)
        {
            if (data[index].tekiouKiki !== prevColData)
            {
                prevRowIndex = index
                spanMap[prevRowIndex].col07 = 1
                prevColData = data[index].tekiouKiki
            } else
            {
                spanMap[prevRowIndex].col07++
                data[index].tekiouKiki = ''
            }
        }
        setRowSpanMap(spanMap)
    }
    useEffect(loadData, [])
    useEffect(createRowSpanMap,[data])
    //
    return (
        <>
            <div className='table-group'>
                <label className='table-select-label'>メーカー</label>
                <select className='table-select-menu' title='メーカー' value={itemNo} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                    setItemNo(parseInt(event.target.value))
                }}>
                    {
                        Object.keys(idx).map((value: string, index: number, array: string[]) => {
                            return (
                                <option value={index}>{value}</option>
                            )
                        })
                    }
                </select>
            {
                Object.keys(idx).map((value: string, index: number, array: string[]) => {
                    return (
                        <>
                            {
                                index !== itemNo ? <></> :
                                    <CompatibleInkCartridgeTable manufacturer={value} rows={data} spanMap={ rowSpanMap } idx={idx} />
                            }
                        </>
                    )
                })
            }
            </div>
        </>
    )
}
export default App;
